<template>
  <div class="events-page">
    <h2>События</h2>
    <br />
    <div class="serve-content">
      <ul class="nav nav-tabs justify-content-center">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#active-events">Неотмеченные</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#archive-events">Архив</a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane fade show active" id="active-events">
          <div class="events-body">
            <div class="alert alert-warning" role="alert">
              <h4 class="alert-heading">
                Выезд за пределы разрешенной зоны!
                <font-awesome-icon icon="times" class="icon hide-button" />
              </h4>
              <p>
                Был зафиксирован выезд за пределы установленной границы аренды
                <a href="#">(Проказать на карте)</a>
              </p>
              <hr />
              <p>Дата/ время: 12:00, 26.06.2020</p>
              <p>
                Автомобиль:
                <a href="#">Lada Largus (A000BC72)</a>
              </p>
              <p>
                Водитель:
                <a href="#">Песегов константин Иванович</a>
              </p>
            </div>
            <div class="alert alert-danger" role="alert">
              <h4 class="alert-heading">
                Аварийная ситуация!
                <font-awesome-icon icon="times" class="icon hide-button" />
              </h4>
              <p>
                Превышение максимально допустимого значения акселерометра
                <a href="#">(Проказать на карте)</a>
              </p>
              <hr />
              <p>Дата/ время: 12:00, 26.06.2020</p>
              <p>
                Автомобиль:
                <a href="#">Lada Largus (A000BC72)</a>
              </p>
              <p>
                Водитель:
                <a href="#">Песегов константин Иванович</a>
              </p>
            </div>
            <div class="alert alert-info" role="alert">
              <h4 class="alert-heading">
                Превышение скорости!
                <font-awesome-icon icon="times" class="icon hide-button" />
              </h4>
              <p>
                Зафиксированая скорость: 64км/ч. Максимально допустимая скорость 60км/ч.
                <a href="#">(Проказать на карте)</a>
              </p>
              <hr />
              <p>Дата/ время: 12:00, 26.06.2020</p>
              <p>
                Автомобиль:
                <a href="#">Lada Largus (A000BC72)</a>
              </p>
              <p>
                Водитель:
                <a href="#">Песегов константин Иванович</a>
              </p>
            </div>
          </div>
        </div>
        <div class="tab-pane fade show loader" id="archive-events">
          <div class="card">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Events'
}
</script>

<style scoped>
  .events-page {
    width: 98%;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    padding-top: 20px;
  }
  .alert-info {
    background-color: rgba(98, 173, 191, 0.45);
  }
  .alert-warning {
    background-color: rgba(242, 185, 80, 0.45);
  }
  .alert-danger {
    background-color: rgba(191, 84, 59, 0.45);
  }
  .alert {
    margin-top: 0.5rem;
    height: 80% !important;
  }
  .events-page h2 {
    margin-bottom: 2rem;
  }
  .events-page:before,
  .events-page:after {
    content: "";
    display: block;
    position: absolute;
    bottom: 100%;
    width: 0;
    height: 0;
  }
  .events-page:before {
    right: 11.2rem;
    border: 12px solid transparent;
    border-bottom-color: #ddd;
  }
  .events-page:after {
    right: 11.3rem;
    border: 10px solid transparent;
    border-bottom-color: #fff;
  }
  .hide-button {
    float: right;
    width: 30px;
  }
  .tab-pane {
    padding: 1rem 1.5rem 1rem 1.5rem;
  }
  .card-header .btn-link {
    color: #0597f2;
  }
  .card-header {
    background-color: white !important;
  }
  .nav-tabs {
    border: none;
  }
  .nav-item .nav-link {
    border: none;
    color: #212529;
  }
  .nav-item .nav-link.active {
    color: #0597f2;
    border-bottom: 2px solid #0597f2;
  }
  .card-header {
    padding-bottom: 0;
  }
</style>
